import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

type OrganizationRole = 'MEMBER' | 'TUTOR' | 'ADMIN';

interface OrganizationRoleGuardProps {
  children: ReactNode;
  allowedRoles: OrganizationRole[];
  redirectTo?: string;
}

export function OrganizationRoleGuard({ 
  children, 
  allowedRoles, 
  redirectTo = '/dashboard' 
}: OrganizationRoleGuardProps) {
  const { user, activeOrganization } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!activeOrganization) {
    return <Navigate to={redirectTo} replace />;
  }

  if (!allowedRoles.includes(activeOrganization.role as OrganizationRole)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
